export default function AdminStatusBadge({ active, entity = "client" }) {
  const statusClass = entity === "complex"
    ? (active ? "complex-status-badge--active" : "complex-status-badge--stopped")
    : (active ? "sip-client-badge--active" : "sip-client-badge--stopped");

  return (
    <span className={`complex-edit-badge ${statusClass}`}>
      {active ? "Активен" : "В стопе"}
    </span>
  );
}
